export default __webpack_public_path__ + "static/media/13.4a8fbb76.wav";